// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--aI-ih";
export var Copyright = "styles-module--Copyright--bCSJM";
export var Link = "styles-module--Link--TaGLX";
export var Menu = "styles-module--Menu--4vHmj";
export var Menu_Item = "styles-module--Menu_Item--RKI4F";
export var Menu_Item_Policy = "styles-module--Menu_Item_Policy--BI7Wx";
export var Menu_List = "styles-module--Menu_List--Znnk9";
export var Menu_List_List = "styles-module--Menu_List_List--i5LVw";